export const bigdesAuditTabsConfig = {
  basePath: "/bigdes-operations/audit",
  tabs: [
    {
      id: "application-process-evaluation",
      path: "/bigdes-operations/audit/application-process-evaluation",
      pageKey: "bigdesApplicationProcessEvaluation",
    },
    {
      id: "current-situation-evaluation",
      path: "/bigdes-operations/audit/current-situation-evaluation",
      pageKey: "bigdesCurrentSituationEvaluation",
    },
    {
      id: "audit-reports",
      path: "/bigdes-operations/audit/audit-reports",
      pageKey: "bigdesAuditReports",
    },
  ],
};
